import { HIDE_SINGLE_QUESTION_CONFIRMATION_KEY } from "@constants/evaluationConstants";

export function isHideSingleQuestionConfirmationEnabled(): boolean {
  return (
    localStorage.getItem(HIDE_SINGLE_QUESTION_CONFIRMATION_KEY) === "true"
  );
}

export function setHideSingleQuestionConfirmation(
  dontShowAgain: boolean,
): void {
  localStorage.setItem(
    HIDE_SINGLE_QUESTION_CONFIRMATION_KEY,
    String(dontShowAgain),
  );
}

export function isSingleQuestionTask(questionCount: number): boolean {
  return questionCount === 1;
}
